webpackJsonp([156188412418577],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/error.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _markdownIt = __webpack_require__("./node_modules/markdown-it/index.js");
	
	var _markdownIt2 = _interopRequireDefault(_markdownIt);
	
	var _footer = __webpack_require__("./src/components/footer/index.js");
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _header = __webpack_require__("./src/components/header/index.js");
	
	var _header2 = _interopRequireDefault(_header);
	
	var _nav = __webpack_require__("./src/components/nav/index.js");
	
	var _nav2 = _interopRequireDefault(_nav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var md = new _markdownIt2.default();
	
	var NotFoundPage = function (_React$Component) {
	  _inherits(NotFoundPage, _React$Component);
	
	  function NotFoundPage() {
	    _classCallCheck(this, NotFoundPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  NotFoundPage.prototype.render = function render() {
	    var page = this.props.data.contentfulPage;
	    var headerTitle = md.renderInline(page.headerTitle.headerTitle);
	    var footer = {
	      footerCatchphrase: page.footerCatchphrase.footerCatchphrase,
	      footerNav: page.footerNav
	    };
	    console.log();
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_nav2.default, { data: page.navigationBar }),
	      _react2.default.createElement(_header2.default, {
	        navItems: page.navigationBar,
	        template: 'secondary',
	        bgImage: page.headerBackground.file.url,
	        headingText: headerTitle,
	        subheadingText: page.headerSubtitle
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-marginVerticalLarge' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Please use the navigation, or click ',
	            _react2.default.createElement(
	              'a',
	              { href: '/', style: { color: '#3138CF' } },
	              'here'
	            ),
	            ' to return to the homepage'
	          )
	        )
	      ),
	      _react2.default.createElement(_footer2.default, { data: footer, secondary: true })
	    );
	  };
	
	  return NotFoundPage;
	}(_react2.default.Component);
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = NotFoundPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-error-js-cecf6a02c78a57b2b91f.js